import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers/cardBlockHelper";
import {
  createH2Block,
  createH4Block,
  createPBlock,
  createUlBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import starBulletPlaceholder from "../../Content/UlListBlock/star_bullet.png";
import { getSalesBlockSecondaryStyleOptions } from "../constants";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "SalesBlock2_2",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Are You Struggling to Reach Your Full Potential?",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: [
        createCardBlock({
          value: [
            createH4Block({
              text: "The Vision",
            }),
            createPBlock({
              text: "Imagine a life where you:",
              paragraphStyle: "p3",
            }),
            createUlBlock({
              items: [
                {
                  text: "Wake up every day with clarity and purpose",
                  placeholder: starBulletPlaceholder,
                },
                {
                  text: "Confidently make decisions aligned with your values",
                  placeholder: starBulletPlaceholder,
                },
                {
                  text: "Achieve meaningful goals without sacrificing your wellbeing",
                  placeholder: starBulletPlaceholder,
                },
                {
                  text: "Build authentic relationships that support your growth",
                  placeholder: starBulletPlaceholder,
                },
                {
                  text: "Create a legacy you're truly proud of",
                  placeholder: starBulletPlaceholder,
                },
              ],
            }),
            createPBlock({
              text: "This transformation isn't just possible—it's within your reach with the right guidance.",
              paragraphStyle: "p3",
            }),
          ],
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockSecondaryStyleOptions(),
      },
    },
  },
};
